export default interface Size {
  width: number;
  height: number;
}

export const sizeToString = (size: Size): string => {
  return `${size.width}x${size.height}`;
};



// WEBPACK FOOTER //
// ./src/data/Size.ts